import { render, staticRenderFns } from "./settleDetail.vue?vue&type=template&id=12952421&scoped=true"
import script from "./settleDetail.vue?vue&type=script&lang=ts"
export * from "./settleDetail.vue?vue&type=script&lang=ts"
import style0 from "./settleDetail.vue?vue&type=style&index=0&id=12952421&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12952421",
  null
  
)

export default component.exports